import React, { useContext } from "react";
import PropTypes from "prop-types";
import AppContext from "../../AppContext";
import { langComponent } from "../../constants";

import "../../styles/support.scss";

// * Icons
import privacyPng from "../../assets/faqs/privacy.png";
import { ReactComponent as PrivacySvg } from "../../assets/faqs/privacy.svg";
import { ReactComponent as JoinSvg } from "../../assets/faqs/join.svg";
import { ReactComponent as UploadSvg } from "../../assets/faqs/upload.svg";
import { ReactComponent as TermSvg } from "../../assets/faqs/terms.svg";
// import { ReactComponent as TenderingSvg } from "../../assets/faqs/tendering.svg";

import { useNavigate } from "react-router-dom";

import Breadcrumb from "../Breadcrumb";

const topics = [
  { name: "Privacy", icon: <PrivacySvg height={48} />, to: "/support/privacy" },
  {
    name: "Terms and Conditions",
    icon: <TermSvg height={36} />,
    to: "/support/terms-and-conditions",
  },
  {
    name: "Joining Us",
    icon: <JoinSvg height={52} />,
    to: "/support/join",
  },
  {
    name: "Uploading",
    icon: <UploadSvg height={34} />,
    to: "/support/upload",
  },
  // {
  //   name: "Tendering",
  //   icon: <TenderingSvg height={34} />,
  //   to: "/support/tendering",
  // },
];

const FAQ = (props) => {
  const navigate = useNavigate();
  const { getLang, faqs } = useContext(AppContext);
  const Translation = getLang(langComponent.support);
  const FAQCategory = faqs?.category;
  const getTopicRender = (icon, topic, to) => {
    return (
      <div
        className="faqs-topics-item"
        onClick={() => navigate(`/support/${to}`)}
      >
        <div className="faqs-topics-item__icon">
          {/* <img alt="faq-icon" src={icon} /> */}
          {/* <Icon /> */}
          {/* {icon} */}
          <img className="" src={icon}></img>
        </div>
        <div className="faqs-topics-item__name">{Translation(topic)}</div>
      </div>
    );
  };

  return (
    <div className="faqs">
      <Breadcrumb
        config={[
          {
            path: "/support",
            breadcrumb: "Support",
            props: { noLink: true },
          },
          {
            path: "/support/faqs",
            breadcrumb: "FAQs",
            props: { className: "about-us" },
          },
        ]}
      />
      <h1 className="faqs__header">{Translation("How can we help?")}</h1>
      <span className="faqs__sub">
        {Translation("Have questions? We're here to help")}
      </span>
      <span className="faqs__sub">
        {Translation(
          "Choose from topics below or start chatting with our support"
        )}
      </span>
      <div className="faqs-topics">
        {FAQCategory?.map((t, i) => {
          return getTopicRender(t.icon, t.name, t.route);
        })}
      </div>
    </div>
  );
};

FAQ.propTypes = {
  onOpenTicket: PropTypes.func,
};

FAQ.defaultProps = {
  onOpenTicket: () => {},
};

export default FAQ;
